<template>
    <div class="price mt-4">
        <div :class="{
                'input-focus-effect': true,
                'rv-valiadate-input-form': error
            }">
            <input :class="price !== '' ? 'border-primary' : ''" type="text" id="inputPrice"
                v-model="price" @focus="e => e.target.select()" inputmode="numeric"/>
            <label :class="{
                    'mb-0': true,
                    'input-on-alue': price !== ''
                }">Giá</label>
        </div>
        <div class="text-danger fs-12px mt-1" v-if="error">{{error}}</div>
    </div>
</template>
<script>
export default {
    props: ['data', 'error'],
    data() {
        return {
            price: ''
        }
    },
    watch: {
        data(val){
            this.price = this.$formatNumber(val);
        },
        price(val){
            this.$emit('update:data', val);
        }
    },
    created() {
        this.price = this.$formatNumber(this.data);
    }
}
</script>
